import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApisService } from 'src/app/services/apis.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-search-popup-component',
  templateUrl: './search-popup-component.component.html',
  styleUrls: ['./search-popup-component.component.scss']
})
export class SearchPopupComponentComponent implements OnInit {

  searchVariable:any;
  searchFlag:boolean = false;
  searchHelperFlag:boolean = false;
  refreshFlag:boolean = false;
  Blogs:any=[];
  searchdata:any;

  constructor(public dialogRef: MatDialogRef<SearchPopupComponentComponent>,
    private apisService : ApisService,
    public dialog: MatDialog) {
     }


  ngOnInit(): void {
  }
  hideSearch(){
    this.searchFlag = false;
    setTimeout(() => {
      this.searchHelperFlag = false;
    }, 200);
  }
  searchblog(data:any){

    console.log(this.searchVariable,'datas')
    if(this.searchVariable != ''){
      var  filter ={
        "where":{
          "$or":[
            {"title":{"$regex":this.searchVariable,"$options": 'i'}},
          ],
        },
        "limit":10,
          "fields":["title","url","categoryids"],
      }
      this.apisService.getsearch(environment.apis.blogs,filter).then((res:any)=>{
        if(res.length > 0){
          this.searchdata = res;
         console.log(res,'search')
        } else {
          this.searchdata = [];
        }
      })
    } else {
      console.log('rohit',this.searchVariable)
      this.searchdata = [];
    }
    
   


  }
  clear(){
    this.searchVariable = '';
    this.searchdata = [];
  }


}
